import { Stack } from "../../../shared/ui/Stack/Stack";
import { Text } from "../../../shared/ui/Text/Text";
import styles from './Contact.module.scss';
import myImg from '../../../shared/assets/photo/contact.png';
import { Link } from "react-router-dom";
import {motion as m} from "framer-motion";

const Contact = () => {
    return ( 
        <section className = {styles.container}>
            <m.div
                initial = 'hidden'
                animate = 'visible'
                variants={{
                    hidden: {
                        opacity: 0,
                    },
                    visible: {
                        opacity: 1,
                        transition: {
                            duration: 2,
                        }
                    }
                }}
            >
            <Stack
                justifyContent = 'justifyCenter'   
                className={styles.title__content}
                
            >
                <m.div
                        variants = {{
                        hidden:{ opacity: 0, y:20},
                        visible: { opacity: 1, y: 0}
                    }}
                    transition = {{ duration: 0.6 }}>
                    <Text type="h3" size='l' className={styles.title}>
                            контакты
                    </Text>  
                </m.div>
            </Stack>
            </m.div>
            
            <Stack
                direction='column'
                justifyContent = 'justifyCenter'
                alignItems='alignCenter'
                gap= '32'
                className = {styles.content}>
                    
                    <m.div
                        initial={{ opacity: 0, y:-20 }}
                        animate={{ opacity: 1, y:0 }}
                        transition={{ duration: 1, delay: 0.8}}>
                    <Text size="l" className = {styles.text}>
                        Просмотрите мои работы, сформируйте стиль и выражение, 
                        которые вы хотите увидеть на своих фотографиях, 
                        расскажите мне о своих предпочтениях и пожеланиях!
                    </Text>
                </m.div>
                <m.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 5, delay: 1}}>
                        <img className={styles.image} src={myImg} alt='Елена Ковешникова'/>
                </m.div>
                    <Text size="l" className = {styles.text}>Буду рада стать Вашим фотографом и создать вместе маленькую историю!</Text>
                    <m.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ staggerChildren: 1 }}>
                    <Stack
                        direction='column'
                        justifyContent = 'justifyCenter'
                        alignItems='alignCenter'
                        gap= '16'
                        className = {styles.content__messenger}>

                                <Link to = "https://max.ru/u/f9LHodD0cOI5Hde4nVzBWMTOd24Lp2829wyKqCSELvk3Zr-eLR87qK4HhAs" className={styles.messenger} target="_blank">
                                    Написать в Max
                                </Link>
                                <Link to = "https://t.me/+79283996411" className={styles.messenger} target="_blank">
                                    Написать в телеграм
                                </Link>
                                <Link to = "https://vk.com/id17296526" className={styles.messenger} target="_blank">
                                    Написать и посмотреть больше фото в вконтакте
                                </Link>
                        
                    </Stack>
                    </m.div>
            </Stack>
        </section>
    );
}

export default Contact;